import { render, staticRenderFns } from "./UnpaidMoneyMessage.vue?vue&type=template&id=4bb661af"
import script from "./UnpaidMoneyMessage.vue?vue&type=script&lang=js"
export * from "./UnpaidMoneyMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports